import React, { useEffect, useState } from 'react';
import TestiMonialsDetails from '../TestiMonialsDetails';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import userPic from '../../images/user-one.png';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';

import './TestiMonials.css';

const TestiMonials = () => {
  
    const testiMonials = [
        {
            name: 'Yann Olivier',
            description: 'Great place to take rest. Near the airport, with useful factory outlets near by. Clean and appealing. I am happy with the service offered',
            address: 'India',
            img: 'https://i.ibb.co/hgGJc8d/Gareth-Bale.jpg'
        },
        {
            name: 'Suraj Hiremath',
            description: 'Great place to stay with clean, hygienic and well maintained rooms.Place is also very close to airport and convenient to travel',
            address: 'India',
            img: 'https://i.ibb.co/z7Kp6yr/np-file-33188.jpg'
        },
        {
            name: 'Kartik Cholachgudda',
            description: 'Great place to rest and best service by the management 🙌👐',
            address: 'India',
            img: 'https://i.ibb.co/CP5sj7g/2856040-58866808-2560-1440.jpg'
        },
        {
            name: 'ABHISHEK RANE',
            description: 'Perfect place to take our partner to spend time.. you know what i mean.',
            address: 'India',
            img: 'https://i.ibb.co/10SYccm/1552313010-354215-noticia-normal.jpg'
        },
        {
            name: 'Subir Raha',
            description: 'Very good atomosphere service or recepton',
            address: 'India',
            img: 'https://i.ibb.co/10SYccm/1552313010-354215-noticia-normal.jpg'
        }
    ]
    //Owl Carousel Settings
    const options = {
        loop: true,
        center: true,
        items: 3,
        margin: 0,
        autoplay: true,
        dots: true,
        autoplayTimeout: 8500,
        smartSpeed: 450,
        nav: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    };
    return (
        <section id="testimonial" className="testimonials pt-70  pb-70">
            <Container fluid  style={{paddingTop:'50px'}}>
                <h4 className="miniTitle text-center">TESTIMONIALS</h4>
                <div className="text-center ">
                    <h3 className="sectionTitle">What Our Clients are Saying?</h3>
                </div>
                {/* <p className="text-center ">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.</p> */}
                <Row  >
                    <Col md={12}>
                    
                        <OwlCarousel id="customer-testimonoals" className="owl-carousel owl-theme"  {...options}>
                            {
                                testiMonials.length === 0 ?
                                    <div class="item">
                                        <div className="shadow-effect">
                                            <img className="img-circle" src={userPic} alt='cir' />

                                            <p>Great place to take rest. Near the airport, with useful factory outlets near by. Clean and appealing. I am happy with the service offered</p>
                                        </div>
                                        <div className="testimonial-name">
                                            <h5>Rajon Rony</h5>
                                            <small>ITALY</small>
                                        </div>
                                    </div> :
                                   
                                    testiMonials.map((testiMonialDetail,index) => {
                                        return (
                                            <TestiMonialsDetails  testiMonialDetail={testiMonialDetail} key={index} />
                                            
                                        )
                                    })
                            }
                        </OwlCarousel>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default TestiMonials;